import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';

import { WarningIndicatorModule } from '@hdms/shared/util-core';

import { ImageModule } from '../../image/image.module';

import { NavButtonComponent } from './nav-button.component';

@NgModule({
  declarations: [NavButtonComponent],
  imports: [CommonModule, ImageModule, WarningIndicatorModule, RouterLink],
  exports: [NavButtonComponent]
})
export class NavButtonModule {}

export * from './nav-button.component';
